import { render, staticRenderFns } from "./statusArchive.vue?vue&type=template&id=4da594ee&"
import script from "./statusArchive.vue?vue&type=script&lang=js&"
export * from "./statusArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports